import * as React from 'react';

import { cn } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

interface CountPillProps {
  /** Additional classes applied to the pill (for caller-specific positioning). */
  className?: string;
  /** The count value or label to display inside the pill. */
  children: React.ReactNode;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Compact count chip used for index indicators and overflow badges in order views.
 *
 * Unified style based on the tasks-section index chip variant:
 *   - rounded-md (not rounded-full) to match the design reference
 *   - font-bold tabular-nums for legible numeric content
 *   - bg-muted text-muted-foreground for neutral emphasis
 */
export function CountPill({ children, className }: CountPillProps): React.JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-md bg-muted px-1.5 text-xs font-bold tabular-nums text-muted-foreground',
        className,
      )}
    >
      {children}
    </span>
  );
}
